export default "__VITE_ASSET__CycRk4hg__"